'use client';

import { query, space } from '@design/templateFns';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface ContainerProps {
  children: ReactNode;
  hasGutter?: boolean;
  style?: Record<string, string>;
}

export const ContentContainer: FC<ContainerProps> = ({ hasGutter = false, children, style }) => {
  return (
    <StyledContainer style={{ ...style }} $gutter={hasGutter}>
      {children}
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $gutter: boolean }>`
  max-width: 1272px;
  width: calc(100% - ${space('x12')} - ${space('x12')});
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ $gutter }) => ($gutter ? space('lg') : 0)};
  padding-right: ${({ $gutter }) => ($gutter ? space('lg') : 0)};
  @media screen and (${query.below('desktop')}) {
    width: calc(100% - ${space('marginTablet')} - ${space('marginTablet')});
  }
  @media screen and (${query.below('tablet')}) {
    width: calc(100% - ${space('marginMobile')} - ${space('marginMobile')});
  }
`;
